import React from "react";
import { StyleSheet } from "react-native";

import { Text } from "../../../../primitive";

type ToggleSwitchLabelProps = {
  label?: string;
  isDisabled?: boolean;
  showToggleLabel?: boolean;
};

export const ToggleSwitchLabel = ({
  label,
  isDisabled,
  showToggleLabel,
}: ToggleSwitchLabelProps) => {
  if (!label) {
    return null;
  }

  return (
    <Text
      style={showToggleLabel ? styles.legacyToggleLabel : undefined}
      variant={showToggleLabel ? "mainSmallSemiBold" : "mainBaseMedium"}
      color={isDisabled && showToggleLabel ? "text-secondary" : "text-primary"}
    >
      {label}
    </Text>
  );
};

const styles = StyleSheet.create({
  legacyToggleLabel: {
    width: 23,
  },
});
